import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexCenter, NumberDisplay, SpaceBetween, TextBody, TextBodySkeleton, Tooltip } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { readSwapImpact } from "../../../provider/readSwapImpact";
import { SWAP_IMPACT_WARNING_THRESHOLD } from "../../constants";
import { SwapDetailsSwapImpactItemFragment } from "./SwapDetailsSwapImpactItem.fragment";
export function SwapDetailsSwapImpactItem(t0) {
  const $ = _c(24);
  const {
    swapRoute: swapRouteKey
  } = t0;
  const swapRoute = readFragment(SwapDetailsSwapImpactItemFragment, swapRouteKey);
  const t = useTranslations("wallet.SwapDetailsSwapImpactItem");
  if (!swapRoute || swapRoute.__typename !== "SwapRoute") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsSwapImpactItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const swapImpact = readSwapImpact(swapRoute);
  if (!swapImpact) {
    return null;
  }
  const hasHighImpact = bn(swapImpact.percent).lt(SWAP_IMPACT_WARNING_THRESHOLD);
  let t1;
  if ($[1] !== t) {
    t1 = t("swapImpact");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("swapImpactTooltip");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="max-w-[200px]">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Info size={16} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <Tooltip content={t4}>{t5}</Tooltip>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <FlexCenter className="gap-1">{t2}{t6}</FlexCenter>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const T0 = TextBody;
  const t8 = true;
  const t9 = hasHighImpact ? "error-1" : "inherit";
  const T1 = NumberDisplay;
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      maximumFractionDigits: 2
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = "percent";
  const t12 = bn(swapImpact.percent).div(100);
  let t13;
  if ($[16] !== T1 || $[17] !== t10 || $[18] !== t12) {
    t13 = <T1 custom={t10} display={t11} value={t12} />;
    $[16] = T1;
    $[17] = t10;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== T0 || $[21] !== t13 || $[22] !== t9) {
    t14 = <T0 asChild={t8} color={t9}>{t13}</T0>;
    $[20] = T0;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return <SpaceBetween>{t7}<FlexCenter className="gap-1.5"><TextBody className="font-mono" color="text-secondary">(<NumberDisplay display="usd" value={swapImpact.usd} />)</TextBody>{t14}</FlexCenter></SpaceBetween>;
}
const SwapDetailsSwapImpactItemSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsSwapImpactItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("swapImpact");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBodySkeleton className="w-[120px]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};